import { ICategoryItem, IContractsResponse } from '@/api/contract/type'
import Page0 from './Page0'
import Page1 from './Page1'
import Page2 from './Page2'
import Page3 from './Page3'
import Page4 from './Page4'
import Page5 from './Page5'
import Page6 from './Page6'

export type ContractProps = {
  data?: IContractsResponse
  category: ICategoryItem | null | undefined
}

const ContractHtml: React.FC<ContractProps> = ({ data, category }) => {
  return (
    <div className="contract-root contract-preview">
      <Page0 data={data} />
      <Page1 data={data} />
      <Page2 data={data} category={category} />
      <Page3 data={data} />
      <Page4 data={data} />
      <Page5 data={data} />
      <Page6 data={data} />
    </div>
  )
}

export default ContractHtml
